//import { alertConstants } from '../constants';

export const loaderMaskActions = {
    show,
    hide
};

function show(message) {
    return { type: 'show', message };
}

function hide(message) {
    return { type: 'hide', show: false };
}